module.exports = __webpack_public_path__ + "img/concrete.86f1ece8.png";